import React, { useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@mui/material';
import usersService from '../../axios/usersService';
import PolicyModalContent from './PolicyModalContent';

const PolicyModal = ({ open, onAccept }) => {
  const [policyAccepted, setPolicyAccepted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleAccept = async () => {
    if (!policyAccepted) return;

    setIsSubmitting(true);
    try {
      onAccept();
    } catch (error) {
      console.error('Error updating user policy agreement:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogTitle>US Foods Shared Table User License Agreement</DialogTitle>
      <DialogContent>
        <Box sx={{ my: 2, maxHeight: '400px', overflow: 'auto', p: 2, border: '1px solid #e0e0e0' }}>
          <PolicyModalContent />
        </Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={policyAccepted}
              onChange={(e) => setPolicyAccepted(e.target.checked)}
              color="primary"
            />
          }
          label="I have read and agree to the terms and conditions"
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleAccept}
          color="primary"
          variant="contained"
          disabled={!policyAccepted || isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Accept'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PolicyModal;
